module.exports = __webpack_public_path__ + "img/approved.a12bb672.svg";